/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { useConsoleServiceStore } from 'dxpConsoleCore-mf/State';
import { EntityDxpUserMeOrganisation } from '../../Services/console';

/**
 * Check if a feature has been enabled for the current tenant.
 */
export const isFeatureEnabled = (featureFlagId: string): boolean => {
  // Console service
  const { tenant } = useConsoleServiceStore.getState();

  if (tenant) {
    const { tenantFeatureFlags } = tenant as EntityDxpUserMeOrganisation;

    // Find the specified feature within the tenant
    const targetFeature = tenantFeatureFlags.filter((flag) => flag.id === featureFlagId);

    // If the feature is valid, check whether it is enabled
    if (targetFeature.length) {
      return targetFeature[0].isEnabled;
    }
  }

  // By default, the check is false
  return false;
};
